import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const LockedIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 14 16"
  >
    <path d="M7 12.875c.25 0 .438-.062.625-.25a.87.87 0 0 0 .25-.625v-2c0-.25-.094-.437-.25-.625-.187-.156-.375-.25-.625-.25a.87.87 0 0 0-.625.25.8.8 0 0 0-.25.625v2c0 .25.063.469.25.625.156.188.375.25.625.25M14 7.5c0-.406-.156-.75-.437-1.062C13.25 6.156 12.906 6 12.5 6h-1V4.531c0-.812-.219-1.562-.625-2.25S9.938 1.031 9.25.625a4.36 4.36 0 0 0-4.5 0c-.687.406-1.25.938-1.656 1.625S2.5 3.688 2.5 4.5V6h-1c-.437 0-.781.156-1.062.438A1.42 1.42 0 0 0 0 7.5v7c0 .438.125.781.438 1.063.28.312.625.437 1.062.437h11c.406 0 .75-.125 1.063-.437.28-.282.437-.626.437-1.063zM4 6V4.5c0-.812.281-1.531.875-2.125A2.92 2.92 0 0 1 7 1.5c.813 0 1.531.313 2.125.875.563.594.875 1.313.875 2.125V6zm8.5 1.5v7h-11v-7z" />
  </svg>
);
LockedIcon.id = 'LockedIcon';
LockedIcon.displayName = 'LockedIcon';
export default LockedIcon;
